import { colors } from "./colors";
import
{
  CardGiftcardOutlined,
  // HistoryOutlined,
  EventOutlined,
  Restore,
  Verified,
  VerifiedOutlined,
} from "@mui/icons-material";
import
{
  subscriptionAnnualFeatures,
  subscriptionMonthlyFeatures,
  nonCommercialFeatures,
  personalLicenseFeatures,
  clubLicenseFeatures,
  limitedTrialFeatures,
} from "./features";

export const licenceTypes = {
  nonCommercial: "Non Commercial",
  trial: "Limited Trial",
  clubSub: "Club Subscription",
  personalSub: "Personal Subscription",
};

export const licenceHandles = {
  nonCommercial: "Non Commercial",
  trial: "Limited Trial",
  index_personal_year: "Annual Personal Subscription",
  index_personal_month: "Monthly Personal Subscription",
  index_club_year: "Annual Club Subscription",
  index_club_month: "Monthly Club Subscription",
  index_elite_month: "Monthly Elite Subscription",
  index_elite_year: "Annual Elite Subscription",
  personalSub: "Personal Subscription",
  squadsPro: "squadspro Subscription"
};
export const licencePeriods = {
  annually: {
    stripe: "year",
    cms: 'year',
    display: "Annual",
  },
  monthly: {
    stripe: "Monthly",
    cms: 'month',
    display: "Monthly",
  },

};
export const licenceOptions = [
  {
    id: 1,
    avatarBgColor: colors.beige,
    icon: <CardGiftcardOutlined />,
    title: licenceTypes.nonCommercial,
    features: nonCommercialFeatures,
    isRecommended: false,
  },
  {
    id: 8,
    avatarBgColor: colors.secondaryPurple,
    icon: <Restore />,
    title: licenceTypes.trial,
    shortTitle: "Limited Trial",
    features: limitedTrialFeatures,
    isRecommended: false,
    licenceId: "trial_index_personal",
  },
  {
    id: 3,
    avatarBgColor: colors.secondaryOrange,
    icon: <EventOutlined />,
    title: licenceTypes.personalSub,
    shortTitle: "Personal",
    features: personalLicenseFeatures,
    isRecommended: false,
    licenceId: "index-personal",
  },
  {
    id: 5,
    avatarBgColor: colors.primaryOrange,
    icon: <VerifiedOutlined />,
    title: licenceTypes.clubSub,
    shortTitle: "Club",
    features: clubLicenseFeatures,
    isRecommended: true,
    licenceId: "index-club",
  },
];

export const rezzilPlayerLicenceOptions = [
  {
    id: 1,
    avatarBgColor: colors.secondaryOrange,
    icon: <EventOutlined />,
    title: licenceTypes.monthlySub,
    features: [],
    isRecommended: false,
    licenceId: "squadspro",
    billingPeriod: "month",
  },
  {
    id: 2,
    avatarBgColor: colors.primaryOrange,
    icon: <VerifiedOutlined />,
    title: licenceTypes.annualSub,
    features: [],
    isRecommended: true,
    licenceId: "squadspro",
    billingPeriod: "year",
  },
];
